import React from 'react';

const Nav = ({ appNavLeft, appNavRight }) => {
  return (
    <div className='h-12 border-b border-gray-300'>
      <div className='h-full  flex items-center container mx-auto px-4 flex justify-between'>
        <ul className='flex h-full'>
          {appNavLeft.map((nav, index) => (
            <li key={index}>
              <a
                href={nav.url}
                className='block mr-6 hover:text-gray-900 flex items-center h-full border-b-2 border-white hover:border-orange-500'
              >
                {nav.title}
              </a>
            </li>
          ))}
        </ul>
        {appNavRight.map((nav, index) => (
          <a
            key={index}
            href={nav.url}
            className='block hover:text-gray-900 flex items-center h-full border-b-2 border-white hover:border-orange-500'
          >
            {nav.title}
          </a>
        ))}
      </div>
    </div>
  );
};

export default Nav;
